// extracted by mini-css-extract-plugin
module.exports = {"datepicker":"styles_datepicker__1Ha6S","label":"styles_label__5HrR7"};